/**
* Created by vouill on 8/22/18.
*/

<template>
  <div>
    <global-container :padding-top="true">
      <event-header :vuex-api-data="vuexApiData" />
      <div class="content"><v-showdown :source="vuexApiData.items[0].fields.description"/></div>
    </global-container>
  </div>
</template>

<script>
import EventHeader from "./EventHeader";

export default {
  name: "Evenement",
  props: { vuexApiData: Object },
  components: { EventHeader },
  data() {
    return {};
  }
};
</script>
